import { render, staticRenderFns } from "./PublishingProjectsList.vue?vue&type=template&id=215ba818"
import script from "./PublishingProjectsList.vue?vue&type=script&lang=js"
export * from "./PublishingProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports